// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* XTAM Spinner - Colores oficiales: #A61B34 (rojo), #8B1528 (rojo oscuro) */

.xtam-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.xtam-spinner--fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background: linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 50%, #0a0a0a 100%);
  background-image:
    linear-gradient(135deg, rgba(166, 27, 52, 0.12) 0%, transparent 50%),
    linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 50%, #0a0a0a 100%);
}

.xtam-spinner--inline {
  padding: 80px 20px;
  min-height: 200px;
}

.xtam-spinner--small {
  padding: 24px;
  gap: 12px;
}

.xtam-spinner--tiny {
  padding: 8px 12px;
  gap: 6px;
  flex-direction: row;
}

/* Contenedor del anillo + logo */
.xtam-spinner__visual {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Anillo giratorio con colores XTAM */
.xtam-spinner__ring {
  position: relative;
  width: 80px;
  height: 80px;
}

.xtam-spinner--inline .xtam-spinner__ring {
  width: 80px;
  height: 80px;
}

.xtam-spinner--fullscreen .xtam-spinner__ring {
  width: 96px;
  height: 96px;
}

.xtam-spinner--small .xtam-spinner__ring {
  width: 48px;
  height: 48px;
}

.xtam-spinner__ring-segment {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: #A61B34;
  border-right-color: #A61B34;
  animation: xtam-spinner-spin 1s cubic-bezier(0.5, 0, 0.5, 1) infinite;
}

.xtam-spinner__ring-segment:nth-child(2) {
  animation-delay: -0.5s;
  border-top-color: #8B1528;
  border-right-color: transparent;
  border-left-color: #8B1528;
}

.xtam-spinner--small .xtam-spinner__ring-segment {
  border-width: 2px;
}

.xtam-spinner--tiny .xtam-spinner__ring-segment {
  border-width: 2px;
}

.xtam-spinner--tiny .xtam-spinner__logo-wrapper {
  width: 14px;
  height: 14px;
}

.xtam-spinner--tiny .xtam-spinner__message {
  font-size: 12px;
}

/* Logo centrado dentro del anillo */
.xtam-spinner__logo-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  animation: xtam-spinner-pulse 2s ease-in-out infinite;
}

.xtam-spinner--fullscreen .xtam-spinner__logo-wrapper {
  width: 48px;
  height: 48px;
}

.xtam-spinner--small .xtam-spinner__logo-wrapper {
  width: 24px;
  height: 24px;
}

.xtam-spinner__logo {
  width: 100%;
  height: 100%;
  object-fit: contain;
  filter: brightness(0) invert(1);
  opacity: 0.95;
}

.xtam-spinner--fullscreen .xtam-spinner__logo {
  filter: brightness(0) invert(1) drop-shadow(0 0 12px rgba(166, 27, 52, 0.4));
}

/* Mensaje */
.xtam-spinner__message {
  margin: 0;
  font-size: 14px;
  color: #9ca3af;
  font-weight: 500;
}

.xtam-spinner--fullscreen .xtam-spinner__message {
  font-size: 16px;
  color: #e5e7eb;
}

.xtam-spinner--small .xtam-spinner__message {
  font-size: 12px;
}

@keyframes xtam-spinner-spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes xtam-spinner-pulse {
  0%, 100% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
  50% {
    opacity: 0.9;
    transform: translate(-50%, -50%) scale(1.02);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/XTAMSpinner.css"],"names":[],"mappings":"AAAA,4EAA4E;;AAE5E;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,0EAA0E;EAC1E;;kEAEgE;AAClE;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,QAAQ;EACR,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,2BAA2B;EAC3B,qEAAqE;AACvE;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qDAAqD;AACvD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,4EAA4E;AAC9E;;AAEA,YAAY;AACZ;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,UAAU;IACV,yCAAyC;EAC3C;EACA;IACE,YAAY;IACZ,4CAA4C;EAC9C;AACF","sourcesContent":["/* XTAM Spinner - Colores oficiales: #A61B34 (rojo), #8B1528 (rojo oscuro) */\n\n.xtam-spinner {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n}\n\n.xtam-spinner--fullscreen {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 9999;\n  background: linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 50%, #0a0a0a 100%);\n  background-image:\n    linear-gradient(135deg, rgba(166, 27, 52, 0.12) 0%, transparent 50%),\n    linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 50%, #0a0a0a 100%);\n}\n\n.xtam-spinner--inline {\n  padding: 80px 20px;\n  min-height: 200px;\n}\n\n.xtam-spinner--small {\n  padding: 24px;\n  gap: 12px;\n}\n\n.xtam-spinner--tiny {\n  padding: 8px 12px;\n  gap: 6px;\n  flex-direction: row;\n}\n\n/* Contenedor del anillo + logo */\n.xtam-spinner__visual {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Anillo giratorio con colores XTAM */\n.xtam-spinner__ring {\n  position: relative;\n  width: 80px;\n  height: 80px;\n}\n\n.xtam-spinner--inline .xtam-spinner__ring {\n  width: 80px;\n  height: 80px;\n}\n\n.xtam-spinner--fullscreen .xtam-spinner__ring {\n  width: 96px;\n  height: 96px;\n}\n\n.xtam-spinner--small .xtam-spinner__ring {\n  width: 48px;\n  height: 48px;\n}\n\n.xtam-spinner__ring-segment {\n  position: absolute;\n  inset: 0;\n  border-radius: 50%;\n  border: 3px solid transparent;\n  border-top-color: #A61B34;\n  border-right-color: #A61B34;\n  animation: xtam-spinner-spin 1s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n}\n\n.xtam-spinner__ring-segment:nth-child(2) {\n  animation-delay: -0.5s;\n  border-top-color: #8B1528;\n  border-right-color: transparent;\n  border-left-color: #8B1528;\n}\n\n.xtam-spinner--small .xtam-spinner__ring-segment {\n  border-width: 2px;\n}\n\n.xtam-spinner--tiny .xtam-spinner__ring-segment {\n  border-width: 2px;\n}\n\n.xtam-spinner--tiny .xtam-spinner__logo-wrapper {\n  width: 14px;\n  height: 14px;\n}\n\n.xtam-spinner--tiny .xtam-spinner__message {\n  font-size: 12px;\n}\n\n/* Logo centrado dentro del anillo */\n.xtam-spinner__logo-wrapper {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  pointer-events: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  animation: xtam-spinner-pulse 2s ease-in-out infinite;\n}\n\n.xtam-spinner--fullscreen .xtam-spinner__logo-wrapper {\n  width: 48px;\n  height: 48px;\n}\n\n.xtam-spinner--small .xtam-spinner__logo-wrapper {\n  width: 24px;\n  height: 24px;\n}\n\n.xtam-spinner__logo {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  filter: brightness(0) invert(1);\n  opacity: 0.95;\n}\n\n.xtam-spinner--fullscreen .xtam-spinner__logo {\n  filter: brightness(0) invert(1) drop-shadow(0 0 12px rgba(166, 27, 52, 0.4));\n}\n\n/* Mensaje */\n.xtam-spinner__message {\n  margin: 0;\n  font-size: 14px;\n  color: #9ca3af;\n  font-weight: 500;\n}\n\n.xtam-spinner--fullscreen .xtam-spinner__message {\n  font-size: 16px;\n  color: #e5e7eb;\n}\n\n.xtam-spinner--small .xtam-spinner__message {\n  font-size: 12px;\n}\n\n@keyframes xtam-spinner-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes xtam-spinner-pulse {\n  0%, 100% {\n    opacity: 1;\n    transform: translate(-50%, -50%) scale(1);\n  }\n  50% {\n    opacity: 0.9;\n    transform: translate(-50%, -50%) scale(1.02);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
